module.exports = __webpack_public_path__ + "img/logo-color-tcs.b0330795.webp";